import AppliedFiltersClearAll from "@reactComponents/facetSearchCriteria/AppliedFiltersClearAll";
import FacetSearchCriteriaAliasSearch from "@reactComponents/facetSearchCriteria/facetSearchCriteriaAliasSearch";
import FacetSearchCriteriaCategory from "@reactComponents/facetSearchCriteria/facetSearchCriteriaCategory";

import FacetSearchCriteriaClinicalStatus from "@reactComponents/facetSearchCriteria/facetSearchCriteriaClinicalStatus";
import FacetSearchCriteriaClinicalTrialStages from "@reactComponents/facetSearchCriteria/facetSearchCriteriaClinicalTrialStages";
import FacetSearchCriteriaEntities from "@reactComponents/facetSearchCriteria/facetSearchCriteriaEntities";

import FacetSearchCriteriaEntityValues from "@reactComponents/facetSearchCriteria/facetSearchCriteriaEntityValues";
import FacetSearchCriteriaGeoCoordinates from "@reactComponents/facetSearchCriteria/facetSearchCriteriaGeoCoordinates";
import FacetSearchCriteriaList from "@reactComponents/facetSearchCriteria/facetSearchCriteriaList";

import FacetSearchCriteriaLocations from "@reactComponents/facetSearchCriteria/facetSearchCriteriaLocations";
import FacetSearchCriteriaMutedCompany from "@reactComponents/facetSearchCriteria/facetSearchCriteriaMutedCompany";
import FacetSearchCriteriaQueryTerm from "@reactComponents/facetSearchCriteria/facetSearchCriteriaQueryTerm";

import FacetSearchCriteriaRelationship from "@reactComponents/facetSearchCriteria/facetSearchCriteriaRelationship";
import FacetSearchCriteriaTimeFrame from "@reactComponents/facetSearchCriteria/facetSearchCriteriaTimeFrame";
import { useEffect, useRef } from "react";

const FacetSearchCriteriaContainer = () => {
  const criteriaPanelRef = useRef(null);

  useEffect(() => {
    document.getElementById("panel_container").addEventListener("scroll", _.debounce(() => {
      const heading = document.getElementById("applied-filters-heading-container");
      const panel = criteriaPanelRef.current;

      if (!panel) {
        return;
      }

      const headingRect = heading.getBoundingClientRect();
      const panelRect = panel.getBoundingClientRect();

      if (headingRect.bottom >= panelRect.top) {
        heading.classList.add("applied-filters-heading-shadow");
      } else {
        heading.classList.remove("applied-filters-heading-shadow");
      }
    }, 100));
  }, []);

  return (
    <div id='rspec_criteria_panel' ref={criteriaPanelRef} className='applied_filters_section applied-filters-fade-in'>
      <div className="applied_filters_category">
        <div className="applied_filters_inner">
          <FacetSearchCriteriaCategory />
          <FacetSearchCriteriaQueryTerm />
          <FacetSearchCriteriaTimeFrame />
          <FacetSearchCriteriaEntities />
          <FacetSearchCriteriaEntityValues />
          <FacetSearchCriteriaGeoCoordinates />
          <FacetSearchCriteriaClinicalTrialStages />
          <FacetSearchCriteriaClinicalStatus />
          <FacetSearchCriteriaLocations />
          <FacetSearchCriteriaMutedCompany />
          <FacetSearchCriteriaRelationship />
          <FacetSearchCriteriaList />
          <FacetSearchCriteriaAliasSearch />
        </div>
        <AppliedFiltersClearAll />
      </div>
    </div>
  )
}

window.FacetSearchCriteriaContainer = FacetSearchCriteriaContainer;
export default FacetSearchCriteriaContainer;
